"use client";

import _slicedToArray from "/Users/asmaaelkourchi/frontend/storybook/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import useToken from '../../theme/useToken';
import zIndexContext from '../zindexContext';
export var containerBaseZIndexOffset = {
  Modal: 0,
  Drawer: 0,
  Popover: 70,
  Popconfirm: 70,
  Tooltip: 70,
  Tour: 70
};
export var consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  ColorPicker: 30,
  DatePicker: 50,
  Menu: 50
};

function isContainerType(type) {
  return type in containerBaseZIndexOffset;
}

export function useZIndex(componentType, customZIndex) {
  var _useToken = useToken(),
      _useToken2 = _slicedToArray(_useToken, 2),
      token = _useToken2[1];

  var parentZIndex = React.useContext(zIndexContext);
  var isContainer = isContainerType(componentType);
  var zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;

  if (isContainer) {
    zIndex += token.zIndexPopupBase + containerBaseZIndexOffset[componentType];
  } else {
    zIndex += consumerBaseZIndexOffset[componentType];
  }

  return [parentZIndex === undefined ? customZIndex : zIndex, zIndex];
}